// Departure → arrival pairs per bus route, derived from the GTFS trips so the
// homepage cards, /schedule and the published feed (Rome2Rio, Transit) can't
// disagree. Pure: imports src/seo only.
import { GTFS_TRIPS } from './gtfs';

/** Route config city name → the GTFS stop that route boards or alights at. */
export const STOP_ID_BY_CITY = {
  Nairobi: 'NBO_PARKSIDE',
  JKIA: 'NBO_JKIA',
  Namanga: 'NAMANGA',
  Arusha: 'ARU_KABILA',
  Moshi: 'MOS_YMCA',
};

/**
 * Every bus that lets you board at the route's origin and alight at its
 * destination, as { dep, arr }, earliest first. Empty for hub/private routes or
 * cities without a GTFS stop.
 */
export function departureArrivals(route, trips = GTFS_TRIPS) {
  const from = STOP_ID_BY_CITY[route?.originCity];
  const to = STOP_ID_BY_CITY[route?.destCity];
  if (!from || !to) return [];
  const pairs = [];
  trips.forEach((trip) => {
    const i = trip.stops.findIndex((s) => s.stop_id === from && s.pickup);
    const j = trip.stops.findIndex((s) => s.stop_id === to && s.drop);
    if (i !== -1 && j > i) {
      pairs.push({ dep: trip.stops[i].dep || trip.stops[i].arr, arr: trip.stops[j].arr });
    }
  });
  return pairs.sort((a, b) => a.dep.localeCompare(b.dep));
}

/** "08:00 → 13:40 · 14:00 → 19:30", or '' when the route has no GTFS pairs. */
export function formatDepartureArrivals(route) {
  return departureArrivals(route)
    .map(({ dep, arr }) => `${dep} → ${arr}`)
    .join(' · ');
}
